<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Báo nghỉ" :link="[{ text: 'Báo nghỉ', href: '/absent-request' }]" />
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <AbsentRequestFilter />
    </v-card>
    <AbsentRequestDataTable ref="table" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AbsentRequestFilter from '@/modules/absent-request/AbsentRequestFilter.vue'
import AbsentRequestDataTable from '@/modules/absent-request/AbsentRequestDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    AbsentRequestFilter,
    AbsentRequestDataTable
  }
}
</script>
